'use strict';

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SliderSwatches = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactcss = require('reactcss');

var _reactcss2 = _interopRequireDefault(_reactcss);

var _SliderSwatch = require('./SliderSwatch');

var _SliderSwatch2 = _interopRequireDefault(_SliderSwatch);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var SliderSwatches = exports.SliderSwatches = function SliderSwatches(_ref) {
  var onClick = _ref.onClick,
      hsl = _ref.hsl;
  var styles = (0, _reactcss2["default"])({
    'default': {
      swatches: {
        marginTop: '20px'
      },
      swatch: {
        boxSizing: 'border-box',
        width: '20%',
        paddingRight: '1px',
        "float": 'left'
      },
      clear: {
        clear: 'both'
      }
    }
  }); // Acceptible difference in floating point equality

  var epsilon = 0.1;
  return _react2["default"].createElement('div', {
    style: styles.swatches
  }, _react2["default"].createElement('div', {
    style: styles.swatch
  }, _react2["default"].createElement(_SliderSwatch2["default"], {
    hsl: hsl,
    offset: '.80',
    active: Math.abs(hsl.l - 0.80) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
    onClick: onClick,
    first: true
  })), _react2["default"].createElement('div', {
    style: styles.swatch
  }, _react2["default"].createElement(_SliderSwatch2["default"], {
    hsl: hsl,
    offset: '.65',
    active: Math.abs(hsl.l - 0.65) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
    onClick: onClick
  })), _react2["default"].createElement('div', {
    style: styles.swatch
  }, _react2["default"].createElement(_SliderSwatch2["default"], {
    hsl: hsl,
    offset: '.50',
    active: Math.abs(hsl.l - 0.50) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
    onClick: onClick
  })), _react2["default"].createElement('div', {
    style: styles.swatch
  }, _react2["default"].createElement(_SliderSwatch2["default"], {
    hsl: hsl,
    offset: '.35',
    active: Math.abs(hsl.l - 0.35) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
    onClick: onClick
  })), _react2["default"].createElement('div', {
    style: styles.swatch
  }, _react2["default"].createElement(_SliderSwatch2["default"], {
    hsl: hsl,
    offset: '.20',
    active: Math.abs(hsl.l - 0.20) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
    onClick: onClick,
    last: true
  })), _react2["default"].createElement('div', {
    style: styles.clear
  }));
};

exports["default"] = SliderSwatches;